import type { DashboardState } from '../index';

export const setColors = (state: DashboardState, { payload }: { payload: Record<string, string> }) => {
  state.colors = payload;
};
